<template>
  <div class="d-flex flex-column view-wrapper">
    
    <v-card class="elevation-1 rounded-0 mb-1 flex-shrink-0" color="#009688">
      <v-card-text class="pa-2 d-flex justify-space-between align-center">
        <div>
          <div class="text-subtitle-1 font-weight-bold white--text">
            {{ tituloTabela }}
          </div>
          <div v-if="periodoFormatado && (isNovosOuComVenda || isSemVenda)" class="caption white--text" style="opacity: 0.9;">
            {{ periodoFormatado }}
          </div>
        </div>
        
        <v-chip small color="white" outlined class="font-weight-medium">
          {{ items.length }} {{ textoChip }}
        </v-chip>
      </v-card-text>
    </v-card>

    <div class="content-container flex-grow-1 elevation-1 white" style="position: relative; min-height: 0;">
      
      <div v-if="loading" class="d-flex justify-center align-center fill-height">
        <v-progress-circular indeterminate color="#009688"></v-progress-circular>
      </div>

      <div v-else-if="items.length === 0" class="d-flex justify-center align-center fill-height grey--text">
        <div class="text-center">
          <v-icon size="48" color="grey lighten-2">mdi-account-group-outline</v-icon>
          <p class="mt-2">{{ (isNovosOuComVenda || isSemVenda) ? 'Nenhum cliente encontrado no período.' : 'Nenhum cliente encontrado.' }}</p>
        </div>
      </div>

      <simplebar
        v-else
        :auto-hide="false"
        class="table-scroll-container"
        style="height: 100%; max-width: 100%;"
      >
        <table class="table-custom" :class="{ 'tabela-novos': isNovosOuComVenda }">
          <colgroup v-if="tipoFiltro === 'novos-com-venda'">
            <col style="width: 70px; min-width: 70px;" />
            <col style="width: 85px; min-width: 85px;" />
            <col style="width: auto; min-width: 150px;" />
            <col style="width: 120px; min-width: 100px;" />
            <col style="width: 100px; min-width: 95px;" />
          </colgroup>
          <colgroup v-else-if="tipoFiltro === 'novos'">
            <col style="width: 75px; min-width: 75px;" />
            <col style="width: 95px; min-width: 95px;" />
            <col style="width: auto; min-width: 180px;" />
            <col style="width: 150px; min-width: 130px;" />
          </colgroup>
          <colgroup v-else>
            <col style="width: 80px; min-width: 80px;" />
            <col style="width: auto; min-width: 200px;" />
            <col style="width: 160px; min-width: 130px;" />
          </colgroup>
          <thead class="table-header sticky-header">
            <tr v-if="tipoFiltro === 'novos-com-venda'">
              <th class="text-center pl-2">Código</th>
              <th class="text-center pl-1">Data Cad.</th>
              <th class="text-left pl-2">Nome</th>
              <th class="text-left pl-2">Cidade</th>
              <th class="text-right pr-3">Valor</th>
            </tr>
            <tr v-else-if="tipoFiltro === 'novos'">
              <th class="text-center pl-2">Código</th>
              <th class="text-center pl-1">Data Cad.</th>
              <th class="text-left pl-2">Nome</th>
              <th class="text-left pl-2 pr-3">Cidade</th>
            </tr>
            <tr v-else>
              <th class="text-center pl-2">Código</th>
              <th class="text-left pl-2">Nome</th>
              <th class="text-left pl-2 pr-3">Cidade</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="item.idcliente || index"
              class="table-row"
              :class="{ 'linha-alternada': index % 2 !== 0 }"
            >
              <td class="text-center pl-2 font-weight-medium">
                {{ item.idcliente }}
              </td>

              <td v-if="isNovosOuComVenda" class="text-center pl-1 font-weight-medium teal--text text--darken-3">
                {{ formatarData(item.dataCadastro) }}
              </td>

              <td class="text-left pl-2 text-truncate" :style="tipoFiltro === 'novos-com-venda' ? 'max-width: 180px;' : 'max-width: 260px;'" :title="item.nome">
                {{ item.nome }}
              </td>

              <td class="text-left pl-2 text-truncate" :style="tipoFiltro === 'novos-com-venda' ? 'max-width: 120px;' : 'max-width: 180px;'" :title="item.cidade">
                {{ item.cidade || '-' }}
              </td>

              <td v-if="tipoFiltro === 'novos-com-venda'" class="text-right pr-3 font-weight-bold">
                {{ formatarValor(item.valor) }}
              </td>
            </tr>
          </tbody>
        </table>
      </simplebar>
    </div>

    <v-card class="elevation-4 rounded-0 flex-shrink-0 grey lighten-4">
      <v-card-text class="pa-2">
        <v-row v-if="tipoFiltro === 'novos-com-venda'" no-gutters justify="space-between" align="center">
          <v-col cols="6" class="text-center">
            <div class="caption grey--text text--darken-2">Qtd. Clientes</div>
            <div class="font-weight-bold teal--text text--darken-2 body-2">
              {{ items.length }}
            </div>
          </v-col>
          <v-col cols="6" class="text-center border-left">
            <div class="caption grey--text text--darken-2">Total em Vendas</div>
            <div class="font-weight-black green--text text--darken-3 body-2">
              {{ formatarValor(totalValor) }}
            </div>
          </v-col>
        </v-row>
        <v-row v-else no-gutters justify="center" align="center">
          <v-col cols="12" class="text-center">
            <div class="caption grey--text text--darken-2">
              {{ textoTotalRodape }}
            </div>
            <div class="font-weight-bold teal--text text--darken-2 body-1">
              {{ items.length }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import db from '@/plugins/dexie';

export default {
  name: 'TabelaClientes',

  components: {
    simplebar,
  },

  data() {
    return {
      loading: false,
      items: [],
      periodoFormatado: '',
    };
  },

  computed: {
    tipoFiltro() {
      return this.$route.query.tipo || '';
    },

    isSemVenda() {
      return this.tipoFiltro === 'sem-venda';
    },

    isNovosOuComVenda() {
      return this.tipoFiltro === 'novos' || this.tipoFiltro === 'novos-com-venda';
    },

    tituloTabela() {
      if (this.tipoFiltro === 'novos-com-venda') return 'Tabela de Clientes Novos com Venda';
      if (this.tipoFiltro === 'novos') return 'Tabela de Clientes Novos';
      if (this.tipoFiltro === 'sem-venda') return 'Tabela de Clientes Sem Venda';
      return 'Tabela de Clientes';
    },

    textoChip() {
      if (this.tipoFiltro === 'novos-com-venda') return 'Clientes Novos c/ Venda';
      if (this.tipoFiltro === 'novos') return 'Clientes Novos';
      if (this.tipoFiltro === 'sem-venda') return 'Clientes Sem Venda';
      return 'Clientes';
    },

    textoTotalRodape() {
      if (this.tipoFiltro === 'novos') return 'Total de Clientes Novos';
      if (this.tipoFiltro === 'sem-venda') return 'Total de Clientes Sem Venda';
      return 'Total de Clientes';
    },

    totalValor() {
      return this.items.reduce((acc, item) => acc + (parseFloat(item.valor) || 0), 0);
    },
  },

  created() {
    this.carregarClientes();
  },

  methods: {
    formatarValor(valor) {
      if (valor === undefined || valor === null || isNaN(valor)) return '0,00';
      return Number(valor).toLocaleString('pt-BR', { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      });
    },

    formatarData(dataVal) {
      if (!dataVal) return '-';
      try {
        if (dataVal instanceof Date) {
          if (isNaN(dataVal.getTime())) return '-';
          return dataVal.toLocaleDateString('pt-BR');
        }
        const d = new Date(dataVal);
        if (!isNaN(d.getTime())) {
          return d.toLocaleDateString('pt-BR');
        }
        if (typeof dataVal === 'string' && dataVal.includes('-')) {
          const partes = dataVal.split('T')[0].split('-');
          if (partes.length === 3) {
            return `${partes[2]}/${partes[1]}/${partes[0]}`;
          }
        }
        return String(dataVal);
      } catch (e) {
        return String(dataVal);
      }
    },

    obterDateObjeto(data) {
      if (!data) return null;
      try {
        if (data instanceof Date) {
          return isNaN(data.getTime()) ? null : data;
        }
        if (typeof data === 'string') {
          if (data.includes('/')) {
            const partes = data.split(' ');
            const partesData = partes[0].split('/');
            if (partesData.length === 3) {
              const dataFormatada = `${partesData[2]}-${partesData[1].padStart(2, '0')}-${partesData[0].padStart(2, '0')}`;
              const horaFormatada = partes[1] || '00:00:00';
              const d = new Date(`${dataFormatada}T${horaFormatada}`);
              if (!isNaN(d.getTime())) return d;
            }
          }
          let str = data;
          if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
            str += 'T00:00:00';
          }
          const d = new Date(str);
          if (!isNaN(d.getTime())) return d;
        }
        const d = new Date(data);
        if (!isNaN(d.getTime())) return d;
        return null;
      } catch (e) {
        return null;
      }
    },

    async carregarClientes() {
      this.loading = true;
      this.items = [];

      try {
        const parametro = await db.parametro.toCollection().first();
        const idVendedorLogado = parametro && parametro.idvendedorlogado 
          ? parseInt(parametro.idvendedorlogado, 10) 
          : 0;

        let idEmpresaLogada = 1;
        const registroEmpresa = await db.empresa.limit(1).first();
        if (registroEmpresa && (registroEmpresa.idEmpresa || registroEmpresa.idempresa)) {
          idEmpresaLogada = Number(registroEmpresa.idEmpresa || registroEmpresa.idempresa);
        } else if (parametro && parametro.empresa) {
          idEmpresaLogada = parseInt(parametro.empresa, 10) || 1;
        }

        let inicioPeriodo, fimPeriodo;
        const paramInicio = this.$route.query['created-from'] || this.$route.query['createdFrom'];
        const paramFim = this.$route.query['created-before'] || this.$route.query['createdBefore'];

        if (paramInicio && paramFim) {
          const [anoIni, mesIni, diaIni] = paramInicio.split('-');
          inicioPeriodo = new Date(anoIni, mesIni - 1, diaIni, 0, 0, 0);

          const [anoFim, mesFim, diaFim] = paramFim.split('-');
          fimPeriodo = new Date(anoFim, mesFim - 1, diaFim, 23, 59, 59);
        } else if (paramInicio) {
          const [anoIni, mesIni, diaIni] = paramInicio.split('-');
          inicioPeriodo = new Date(anoIni, mesIni - 1, diaIni, 0, 0, 0);
          fimPeriodo = new Date(anoIni, mesIni - 1, diaIni, 23, 59, 59);
        } else {
          const agora = new Date();
          inicioPeriodo = new Date(agora.getFullYear(), agora.getMonth(), 1, 0, 0, 0);
          fimPeriodo = new Date(agora.getFullYear(), agora.getMonth() + 1, 0, 23, 59, 59);
        }

        const optData = { day: '2-digit', month: '2-digit', year: 'numeric' };
        this.periodoFormatado = `${inicioPeriodo.toLocaleDateString('pt-BR', optData)} até ${fimPeriodo.toLocaleDateString('pt-BR', optData)}`;

        const inicioTime = inicioPeriodo.getTime();
        const fimTime = fimPeriodo.getTime();

        const todosClientes = await db.cliente.toArray();

        if (todosClientes.length === 0) {
          this.loading = false;
          return;
        }

        let filtrados = todosClientes;

        if (idVendedorLogado > 0) {
          filtrados = filtrados.filter(c => !c.idvendedor || Number(c.idvendedor) === idVendedorLogado);
        }

        // Filtra apenas clientes ativos no período (DATAINATIVO vazio ou posterior ao fim do período)
        filtrados = filtrados.filter(c => {
          const dataInativo = c.DATAINATIVO || c.datainativo;
          if (dataInativo === null || dataInativo === undefined || dataInativo === '') return true;
          const dtInativo = this.obterDateObjeto(dataInativo);
          return dtInativo && dtInativo.getTime() > fimTime;
        });

        const mapaValoresVendas = {};

        // Se for filtro de clientes novos com venda
        if (this.tipoFiltro === 'novos-com-venda') {
          const vendasDoVendedor = await db.venda
            .where('idvendedor')
            .equals(Number(idVendedorLogado))
            .toArray();

          const vendasProcessadas = new Set();
          const clientesComVenda = new Set();

          vendasDoVendedor.forEach(v => {
            const dtObj = this.obterDateObjeto(v.data);
            if (!dtObj) return;
            const time = dtObj.getTime();
            const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
            const pertenceAEmpresa = !v.idempresa || Number(v.idempresa) === Number(idEmpresaLogada);
            const naoCancelado = v.cancelado !== 'S';

            if (dentroDoPeriodo && pertenceAEmpresa && naoCancelado) {
              const idCli = Number(v.idcliente);
              clientesComVenda.add(idCli);

              const idVendaUnico = v.idvenda;
              const chave = `${idCli}_${idVendaUnico}`;
              if (!vendasProcessadas.has(chave)) {
                const valorLiquido = parseFloat(String(v.vlrliquidovenda || '0').replace(',', '.')) || 0;
                mapaValoresVendas[idCli] = (mapaValoresVendas[idCli] || 0) + valorLiquido;
                vendasProcessadas.add(chave);
              }
            }
          });

          const pedidosDoVendedor = await db.pedido
            .where('idvendedor')
            .equals(Number(idVendedorLogado))
            .toArray();

          pedidosDoVendedor.forEach(p => {
            const dtObj = this.obterDateObjeto(p.data);
            if (dtObj) {
              const time = dtObj.getTime();
              const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
              const pertenceAEmpresa = !p.idempresa || Number(p.idempresa) === Number(idEmpresaLogada);
              const naoCancelado = !p.datacancelamento && p.cancelado !== 'S';
              if (dentroDoPeriodo && pertenceAEmpresa && naoCancelado) {
                const idCli = Number(p.idcliente);
                clientesComVenda.add(idCli);

                if (!mapaValoresVendas[idCli]) {
                  const valorPed = parseFloat(String(p.total || '0').replace(',', '.')) || 0;
                  mapaValoresVendas[idCli] = valorPed;
                }
              }
            }
          });

          filtrados = filtrados.filter(c => {
            const dataCad = c.DataCadastro || c.datacadastro;
            const dtObj = this.obterDateObjeto(dataCad);
            if (!dtObj) return false;
            const time = dtObj.getTime();
            const cadastradoNoPeriodo = time >= inicioTime && time <= fimTime;
            const temVenda = clientesComVenda.has(Number(c.idcliente));
            return cadastradoNoPeriodo && temVenda;
          });
        }
        // Se for filtro de clientes novos
        else if (this.tipoFiltro === 'novos') {
          filtrados = filtrados.filter(c => {
            const dataCad = c.DataCadastro || c.datacadastro;
            const dtObj = this.obterDateObjeto(dataCad);
            if (!dtObj) return false;
            const time = dtObj.getTime();
            return time >= inicioTime && time <= fimTime;
          });
        }
        // Se for filtro de clientes sem venda
        else if (this.tipoFiltro === 'sem-venda') {
          const vendasDoVendedor = await db.venda
            .where('idvendedor')
            .equals(Number(idVendedorLogado))
            .toArray();

          const clientesComVenda = new Set();

          vendasDoVendedor.forEach(v => {
            const dtObj = this.obterDateObjeto(v.data);
            if (!dtObj) return;
            const time = dtObj.getTime();
            const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
            const pertenceAEmpresa = !v.idempresa || Number(v.idempresa) === Number(idEmpresaLogada);
            const naoCancelado = v.cancelado !== 'S';

            if (dentroDoPeriodo && pertenceAEmpresa && naoCancelado) {
              clientesComVenda.add(Number(v.idcliente));
            }
          });

          const pedidosDoVendedor = await db.pedido
            .where('idvendedor')
            .equals(Number(idVendedorLogado))
            .toArray();

          pedidosDoVendedor.forEach(p => {
            const dtObj = this.obterDateObjeto(p.data);
            if (dtObj) {
              const time = dtObj.getTime();
              const dentroDoPeriodo = time >= inicioTime && time <= fimTime;
              const pertenceAEmpresa = !p.idempresa || Number(p.idempresa) === Number(idEmpresaLogada);
              const naoCancelado = !p.datacancelamento && p.cancelado !== 'S';
              if (dentroDoPeriodo && pertenceAEmpresa && naoCancelado) {
                clientesComVenda.add(Number(p.idcliente));
              }
            }
          });

          filtrados = filtrados.filter(c => {
            const dataCad = c.DataCadastro || c.datacadastro;
            const dtCadObj = this.obterDateObjeto(dataCad);
            const cadTime = dtCadObj ? dtCadObj.getTime() : 0;
            const cadastradoAteFim = cadTime <= fimTime;
            const naoTemVenda = !clientesComVenda.has(Number(c.idcliente));

            return cadastradoAteFim && naoTemVenda;
          });
        }

        const cidadeFiltro = this.$route.query.cidade ? this.$route.query.cidade.toLowerCase().trim() : '';
        if (cidadeFiltro) {
          filtrados = filtrados.filter(c => c.cidade && c.cidade.toLowerCase().includes(cidadeFiltro));
        }

        this.items = filtrados.map(c => {
          const dataCad = c.DataCadastro || c.datacadastro;
          const dtObj = this.obterDateObjeto(dataCad);
          const idCli = Number(c.idcliente);
          const valorVendas = mapaValoresVendas[idCli] || 0;

          return {
            idcliente: c.idcliente,
            nome: (c.nome || c.nomefantasia || '').trim(),
            cidade: (c.cidade || '').trim(),
            dataCadastro: dtObj || dataCad,
            dataCadastroObjeto: dtObj,
            valor: valorVendas,
          };
        });

        this.items.sort((a, b) => {
          if (this.tipoFiltro === 'novos-com-venda') {
            if (b.valor !== a.valor) {
              return b.valor - a.valor;
            }
          }
          if (this.isNovosOuComVenda) {
            const dtA = a.dataCadastroObjeto ? a.dataCadastroObjeto.getTime() : 0;
            const dtB = b.dataCadastroObjeto ? b.dataCadastroObjeto.getTime() : 0;
            if (dtB !== dtA) {
              return dtB - dtA;
            }
          }
          const nomeA = a.nome || '';
          const nomeB = b.nome || '';
          return nomeA.localeCompare(nomeB, 'pt-BR', { sensitivity: 'base' });
        });

      } catch (error) {
        console.error('Erro ao carregar clientes:', error);
      } finally {
        this.loading = false;
      }
    }
  },

  watch: {
    '$route.query': {
      deep: true,
      handler() {
        this.carregarClientes();
      },
    },
  },
};
</script>

<style scoped>
.view-wrapper {
  height: calc(100vh - 100px);
  background-color: white;
}

.table-custom {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  min-width: 450px;
}

.table-custom.tabela-novos {
  min-width: 540px;
}

.table-header th {
  background-color: #f5f5f5;
  color: #616161;
  padding: 10px 6px;
  font-size: 0.75rem;
  text-transform: uppercase;
  border-bottom: 2px solid #e0e0e0;
  white-space: nowrap;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 2px 2px -1px rgba(0,0,0,0.1);
}

.table-row td {
  padding: 8px 6px;
  border-bottom: 1px solid #eeeeee;
  font-size: 0.85rem;
  color: #424242;
  white-space: nowrap;
}

.linha-alternada {
  background-color: #fafafa;
}

.border-left {
  border-left: 1px solid #e0e0e0;
}
.border-right {
  border-right: 1px solid #e0e0e0;
}

/* Configuração do Simplebar para scroll horizontal */
.table-scroll-container {
  overflow-x: auto;
}

.table-scroll-container ::v-deep .simplebar-scrollbar::before {
  background: #009688 !important;
}
</style>